export function extractBildebankenIdFromUrl(url: string) {
  const bildebanken = /^https:\/\/bildebanken(-[^.]+)?\.nrk\.no\/images\/([^/]{36})$/;
  const bildebankenUrl = url.match(bildebanken);
  if (bildebankenUrl) {
    return bildebankenUrl[2];
  }
  return undefined;
}

export function extractNtbIdFromUrl(url: string) {
  const ntb = /^https:\/\/bilder\.ntb\.no\/r\/preview\/editorial\/([a-zA-Z0-9_-]+)(.*)$/;
  const ntbUrl = url.match(ntb);
  if (ntbUrl) {
    return ntbUrl[1];
  }
  const bildebanken =
    /^https:\/\/bildebanken(-[^.]+)?\.nrk\.no\/images\/ntb\/([a-zA-Z0-9_-]+)(.*)$/;
  const bildebankenUrl = url.match(bildebanken);
  if (bildebankenUrl) {
    return bildebankenUrl[2];
  }
  return undefined;
}

export function extractKaleidoIdFromUrl(url: string) {
  const kaleidoPattern =
    /^https:\/\/kaleido(-[^.]+)?\.nrk\.no\/service\/api\/1\.0\/data\/([^/]{22})$/;
  const kaleidoUrl = url.match(kaleidoPattern);
  if (kaleidoUrl) {
    return kaleidoUrl[2];
  }
  const gfxPattern = /^https:\/\/gfx(-[^.]+)?\.nrk\.no\/([^/]{44})(.*)$/;
  const gfxUrl = url.match(gfxPattern);
  if (gfxUrl) {
    return gfxUrl[2].substring(0, 22);
  }
  const bildebankenPattern =
    /^https:\/\/bildebanken(-[^.]+)?\.nrk\.no\/images\/kaleido\/([^/]{22})$/;
  const bildebankenUrl = url.match(bildebankenPattern);
  if (bildebankenUrl) {
    return bildebankenUrl[2];
  }
  return undefined;
}
